<style>
  div {
    background-color: transparent;
  }
</style>
    <div style="background-color: transparent; height: 5000; width: 4500;">
      <router-outlet></router-outlet>
    </div>


    <!-- <fadv-content>
      <fadv-layout>
        <fadv-layout-section position="left" style="height: 1px; width: 1px;">
        <div class="left" style="height: 1px; width: 1px;"></div>
      </fadv-layout-section>
        <fadv-layout-section position="right" style="height: 1px; width: 1px;">
          <div class="right" style="height: 1px; width: 1px;"></div>
        </fadv-layout-section>
        <fadv-layout-section position="top-inner" style="height: 1px; width: 1px;">
          <div class="top-inner" style="height: 1px; width: 1px;"></div>
        </fadv-layout-section>
        <fadv-layout-section position="top-outer" style="height: 1px; width: 1px;">
          <div class="top-outer" style="height: 1px; width: 1px;"></div>
        </fadv-layout-section>
        <fadv-layout-main>
          <div class="main" style="height: 50000; width: 45000;">
            <router-outlet></router-outlet>
          </div>
        </fadv-layout-main>
      </fadv-layout>
    </fadv-content> -->
    